// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e1108e4e","455":"38c13a06","977":"6295dc5b"}[chunkId] + ".chunk.js";
};